import { render, staticRenderFns } from "./nationalInterest.vue?vue&type=template&id=31e542a5&scoped=true&"
import script from "./nationalInterest.vue?vue&type=script&lang=ts&"
export * from "./nationalInterest.vue?vue&type=script&lang=ts&"
import style0 from "./nationalInterest.vue?vue&type=style&index=0&id=31e542a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e542a5",
  null
  
)

export default component.exports